import React, { useState } from 'react';

import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';

import QuickbooksSelect from '.';
import type { QuickbooksEntity } from '../types';

interface Props {
  open: boolean;
  type: 'customer' | 'vendor';
  buildoutObject?: Record<string, unknown>;
  quickbooksId?: number;
  onChange: (value: QuickbooksEntity | null) => void | Promise<void>;
  onClose: () => void;
}

// Modal wrapper around QuickbooksSelect for linking or creating the matching QuickBooks entity.
// Closes itself once the selection has been persisted; keeps itself open and surfaces an error if
// persisting fails so the change isn't silently dropped.
export default function QuickbooksSelectModal({
  open, type, buildoutObject, quickbooksId, onChange, onClose,
}: Props) {
  const [error, setError] = useState('');

  const handleClose = () => {
    setError('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Modal.Content centered>
        <Modal.Header>
          <Modal.Title>Link to QuickBooks {type === 'customer' ? 'Customer' : 'Vendor'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <QuickbooksSelect
            buildoutObject={buildoutObject}
            quickbooksId={quickbooksId}
            type={type}
            onChange={async (entity) => {
              setError('');
              try {
                await onChange(entity);
                handleClose();
              } catch {
                setError('Something went wrong saving the QuickBooks link. Please try again.');
              }
            }}
          />
          {error && (
            <div className="text-danger small mt-1">{error}</div>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}
